import type { ActiveToken, CompletionProvider } from './types'

// Finds the completion token under the caret in a plain <textarea>. Pure and
// framework-free so it carries the unit check (completion.test.ts).
//
// Scans left from the caret for the provider's trigger, stopping at any
// whitespace. Requires a word boundary before the trigger (start-of-input or
// whitespace) so it never fires inside `http://host` or `12:30`.
export function findActiveToken(
  text: string,
  caret: number,
  provider: Pick<CompletionProvider, 'trigger' | 'minChars'>
): ActiveToken | null {
  const { trigger, minChars } = provider
  let i = caret - 1
  for (; i >= 0; i--) {
    const ch = text[i]
    if (ch === trigger) break
    if (ch === ' ' || ch === '\n' || ch === '\t') return null // whitespace before a trigger → no token
  }
  if (i < 0 || text[i] !== trigger) return null // no trigger between caret and the last whitespace

  if (i > 0) {
    const prev = text[i - 1]
    if (prev !== ' ' && prev !== '\n' && prev !== '\t') return null // e.g. the `:` in http:// or 12:30
  }

  const term = text.slice(i + 1, caret)
  if (term.length < minChars) return null // lone `:` or `:s` stays quiet until 2 chars
  return { trigger, term, start: i, end: caret }
}
